import {useMutation, useQueryClient} from '@tanstack/react-query';
import giftCodeUpdaters from '@/api/updaters/giftCodes';
import {CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY} from '@/hooks/queries/use-campaign-v2-creators-counts-query';

function useSendGiftCode() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['giftCodes', 'sendCoupon'],
    mutationFn: giftCodeUpdaters.sendCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({
        queryKey: [CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY],
      });
    },
  });
}

export default useSendGiftCode;
